import { InputText } from 'primereact/inputtext'
import React, { useEffect, useState } from 'react'
import { FilterMatchMode } from 'primereact/api'
import { DataTable, DataTableValue } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { handleLoader, handleNotFound } from 'redux/counterSlice';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import DeleteHistoryModal from 'components/DeleteHistoryModal';
import { delete_history_by_id, get_scrape_histroy } from 'services/webScrapperService';
import { Tag } from 'primereact/tag';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { datatableDelete, datatableDeleteHover, datatableView, datatableViewHover } from 'assets/icons';
const moment = require('moment');

const History = () => {
    const [historyList, setHistoryList] = useState<DataTableValue[]>([])
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState<{ [s: string]: any }>();
    const [scrapID, setScrapID] = useState<any>();
    const [first, setFirst] = useState(0); // State to control the first page
    const [sortField, setSortField] = useState(""); // State to control the first page
    const [sortOrder, setSortOrder] = useState<any>(""); // State to control the first page
    const [rowsPerPage, setRowsPerPage] = useState(5); // State to control the rows per page
    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFirst(0);
        const value = e?.target?.value;
        let _filters = { ...filters };

        _filters['global']!.value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue('');
    };
    const handleSort = (event: any) => {
        setSortField(event.sortField)
        setSortOrder(event.sortOrder)
        setFirst(0);  //Move to page 1
        // dispatch(setFirstVoice(0)); // Move to page 1
    };

    const temp = (e: any) => {
        return e === "successful" ? 'Success' : 'Failed'
    };


    const getWebHistory = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await get_scrape_histroy();
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setHistoryList(result.reverse())
            dispatch(handleLoader(false));
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const deleteHisotryScrap = async (id: string) => {
        dispatch(handleLoader(true));
        try {
            // const res = await axios.delete(`http://172.17.1.53:4009/delete_row?website_id=${id}&client_env=RON`);
            const { result, error } = await delete_history_by_id(id);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            toast.success("Scrapped history deleted successfully", {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
            getWebHistory();
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    useEffect(() => {
        dispatch(handleNotFound(false))
        initFilters()
        // getHistory();
        getWebHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [is_hover_Delete, setIs_hover_Delete] = useState<string>("");
    const [is_hover_eye, setIs_hover_eye] = useState<string>("");

    return (
        <>
            <div className="datatable-wrapper">
                <div className='p-4 content-wrapper'>
                    <div className="switch-section user-management-section">
                        <div className='d-flex align-items-center justify-content-between flex-wrap mb-3 table-top-row'>
                            <h4 className="mb-0">Web Scrapper</h4>
                            <div className="d-flex justify-content-between align-items-center table-right-row">
                                <div className='d-flex align-items-center table-right-first'>
                                    <div className='d-flex align-items-center table-search mr-3 mt-1 mb-1'>
                                        <IconField iconPosition="right" className='user-input'>
                                            <InputIcon className="pi pi-search"></InputIcon>
                                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search by website name" />
                                        </IconField>
                                    </div>
                                    <div className='table-right-end mt-1 mb-1'>
                                        <Button label="New Website Scrapping" outlined icon="pi pi-plus" className='outline-icon-btn' onClick={async () => {
                                            navigate('/admin/web-scrapper/new')
                                        }}></Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <DataTable
                            paginator
                            filters={filters}
                            globalFilterFields={['website_name', 'base_url']}
                            first={first}
                            onPage={(e) => { setFirst(e.first); setRowsPerPage(e.rows) }}
                            rows={rowsPerPage}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            sortMode="single"
                            onSort={handleSort}
                            rowsPerPageOptions={[5, 10, 25]}
                            value={historyList.length > 0 ? historyList : []}
                            tableStyle={{}}
                            emptyMessage="No website records found"
                        >
                            <Column field="website_name" header="Website name" sortable ></Column>
                            <Column field="base_url" header="Website URL"
                                body={(rowData: any) => (<a href={rowData.base_url} target="_blank" rel="noopener noreferrer">{rowData.base_url}</a>)} ></Column>
                            <Column field="total_count" header="Total scraped pages"></Column>
                            <Column
                                field="date"
                                header="Date & Time"
                                body={(rowData: any) => (moment(rowData.created_time).format('MMM DD, YYYY HH:mm:ss'))}
                                sortable
                                sortField='created_time'
                            ></Column>
                            <Column field="status" style={{ cursor: "default" }} header="Status" showFilterMenu={false} filterMenuStyle={{ width: '18rem' }} body={(rowData) => (<Tag
                                className='status-tag' style={{ color: rowData.status === "successful" ? "#01C324" : "#F84F4F", backgroundColor: rowData.status === "successful" ? "rgb(1 195 36 / 8%)" : "rgb(248 79 79 / 10%)" }} value={temp(rowData.status)} />)} />
                            {/* <Column header="Status" dataType="boolean"  body={(rowData) => (<i className={classNames('pi', { 'text-green-500 pi-check-circle': rowData.is_active, 'text-red-500 pi-times-circle': !rowData.is_active })}  onClick={(e) => { roleActive(e,rowData) }}></i>)}/> */}
                            {/* <Column field="status" header="Status" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} body={(rowData) => (<Tag value={rowData.is_active ? 'Active' : 'Inactive'} />)} /> */}
                            <Column header="Action" body={(rowData) => (
                                <div className='d-flex'>
                                    <span className='mr-3 cursor-pointer' onClick={() => navigate(`/admin/web-scrapper/${rowData?.website_id}`)} onMouseEnter={() => setIs_hover_eye(rowData.website_id)} onMouseLeave={() => setIs_hover_eye("")}>
                                        <img src={is_hover_eye === rowData.website_id ? datatableViewHover : datatableView} alt='view-icon' />
                                    </span>
                                    <span className='cursor-pointer' data-bs-toggle="modal" data-bs-target={"#delete-history"} onClick={() => setScrapID(rowData.website_id)} onMouseEnter={() => setIs_hover_Delete(rowData._id)} onMouseLeave={() => setIs_hover_Delete("")}>
                                        <img src={is_hover_Delete === rowData._id ? datatableDeleteHover : datatableDelete} alt='delete-icon' />
                                    </span>
                                </div>)}></Column>
                        </DataTable>
                    </div>
                </div>
            </div>
            <DeleteHistoryModal deleteHistory={deleteHisotryScrap} id={scrapID} />
        </>
    )
}

export default History